// Dynamic QR Code utilities

// Generate a unique 6-character alphanumeric slug
export function generateSlug(): string {
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789';
  let slug = '';
  for (let i = 0; i < 6; i++) {
    slug += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return slug;
}

// Get the redirect URL for a dynamic QR code
export function getRedirectUrl(slug: string): string {
  const projectId = import.meta.env.VITE_SUPABASE_PROJECT_ID || 'vliudbxhddvxvduyjdxl';
  return `https://${projectId}.supabase.co/functions/v1/qr-redirect/${slug}`;
}

// Plan limits configuration
export const planLimits = {
  free: {
    dynamicQRLimit: 5,
    scansLimitMonthly: 50, // 5 dynamic QRs × 10 scans each = 50 scans/month
    name: 'Free',
  },
  starter: {
    dynamicQRLimit: 25,
    scansLimitMonthly: 50000,
    name: 'Starter',
  },
  pro: {
    dynamicQRLimit: 100,
    scansLimitMonthly: -1, // unlimited
    name: 'Pro',
  },
  business: {
    dynamicQRLimit: -1, // unlimited
    scansLimitMonthly: -1, // unlimited
    name: 'Business',
  },
} as const;

export type PlanType = keyof typeof planLimits;

export function getPlanLimits(plan: string) {
  return planLimits[plan as PlanType] || planLimits.free;
}

// Format scan count with trend indicator
export function formatScanCount(count: number): string {
  if (count >= 1000000) {
    return `${(count / 1000000).toFixed(1)}M`;
  }
  if (count >= 1000) {
    return `${(count / 1000).toFixed(1)}K`;
  }
  return count.toString();
}
